import { type BriefType, isManualBriefType } from 'src/data/brief';
import { BRIEF_TYPE } from 'src/data/brief/const';

import { PROJECT_TYPE, type ProjectType } from './const';

const PROJECT_BRIEF_TYPES_ASSOCIATION: Record<string, BriefType> = {
  [PROJECT_TYPE.continuousOptimization]: BRIEF_TYPE.unifiedProduct,
  [PROJECT_TYPE.wtmHomePage]: BRIEF_TYPE.unifiedProduct,
  [PROJECT_TYPE.blogPostBuilder]: BRIEF_TYPE.blogPostBuilder,
  [PROJECT_TYPE.document]: BRIEF_TYPE.canvas,
  [PROJECT_TYPE.longFormBuilder]: BRIEF_TYPE.canvas,
};

export const getBriefTypeByProjectType = (projectType: ProjectType): BriefType =>
  PROJECT_BRIEF_TYPES_ASSOCIATION[projectType];

export const projectTypeSupportsManualBrief = (projectType: ProjectType): boolean => {
  const briefType = getBriefTypeByProjectType(projectType);
  return isManualBriefType(briefType);
};
